import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../utils/intercepter/axiosConfig';
import { jwtDecode } from 'jwt-decode';

const ActeVente = () => {

  const navigate = useNavigate();
  const { id_vente } = useParams();
  const [id_notaire, setIdNotaire] = useState('');

  const [date_acte_vente, setDateActeVente] = useState('');
  const [num_acte_vente, setNumActeVente] = useState('');
  const [id_vente_initier, setIdVenteInitier] = useState(0);
  const [montant, setMontant] = useState('');
  const [num_acte_depo, setNumActeDepo] = useState('');
  const [date_acte_depo, setDateActeDepo] = useState('');

  const [typesActe, setTypesActe] = useState([]);
  const [id_type_acte, setIdTypeActe] = useState('');

  const [allImames, setAllImames] = useState([]);
  const [id_imam, setIdImam] = useState('')

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  
  const [isSubmitting, setIsSubmiting] = useState(false);

  const fetchTypesActe = async () => {
    try {
      
      const response = await api.get("/auth/getAllTypeActe");
      if(response.data.status){
        setTypesActe(response.data.response);
        console.log(response.data.response)
      }
      else{
        console.log(response.data.response.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {

    const token = localStorage.getItem("token");
    if(token){
      const decoded = jwtDecode(token);
      setIdNotaire(decoded.data.id_notaire);
    }
  },[])

  const fetchAllImames = async () => {
    try {

      const response = await api.get("/auth/getImames");
      if(response.data.status){
        setAllImames(response.data.response);
      }
      else{
        console.log(response.data.response)
      }
      
    } catch (error) {
      console.log(error)
    }
  }

  const retour = () => {
    navigate(-1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmiting(true);

    if(id_type_acte === '1' || id_type_acte === '2'){
  
      try {
        const response = await api.post("/auth/initierActeVenteV1",{
          type_acte: id_type_acte,
          num_acte_vente : num_acte_vente,
          date_acte_vente : date_acte_vente,
          id_notaire : id_notaire,
          id_vente : id_vente_initier
        });

        if(response.data.status){
          
          setMessage(response.data.message)
          setMessageType("success")
          
          setTimeout(() => navigate("/mes-ventes"),1000);

        }
        else{
          setMessage(response.data.message)
          setMessageType("error")
        }
      } catch (error) {
        if (error.response) {
                const data = error.response.data;
                setMessage(data.message || "Erreur réseau.");
                setMessageType("error");
            } else {
              setMessage("Erreur réseau.");
              setMessageType("error");
            }
        }finally{
          setIsSubmiting(false);
        }

    }
    else{
      try {
        
        // console.log("type acte : " , id_type_acte);
        // console.log("num_acte_depo : ", num_acte_depo);
        // console.log("date_acte_depo : ", date_acte_depo);
        // console.log("num_acte_vente : ", num_acte_vente);
        // console.log("date_acte_vente : ", date_acte_vente);
        // console.log("id_notaire_acte_depo : ", id_notaire);
        // console.log("id_notaire : ", id_imam);
        // console.log("id_vente : ",id_vente_initier);


        const response = await api.post("/auth/initierActeVenteV2",{
          type_acte : id_type_acte,
          num_acte_depo : num_acte_depo,
          date_acte_depo : date_acte_depo,
          num_acte_vente : num_acte_vente,
          date_acte_vente : date_acte_vente,
          id_notaire_acte_depo : id_notaire,
          id_notaire : id_imam,
          id_vente : id_vente_initier
        });

        if(response.data.status){

          setMessage(response.data.message)
          setMessageType("success")
          
          setTimeout(() => navigate("/mes-ventes"),1000);
          
        }
        else{
          setMessage(response.data.message)
          setMessageType("error")
        }

      } catch (error) {
        if (error.response) {
                const data = error.response.data;
                setMessage(data.message || "Erreur réseau.");
                setMessageType("error");
            } else {
              setMessage("Erreur réseau.");
              setMessageType("error");
            }
        }finally{
          setIsSubmiting(false);
        }
    }

   
  };


  useEffect(() => {
      fetchTypesActe();
      fetchAllImames();
  },[])

  useEffect(() => {
    if (id_vente) {
      setIdVenteInitier(id_vente);
    }
  }, [id_vente]);

  return (
    <div className='main-container'>
      <div className='container'>

        {message && (
                <div className={`mt-3 alert ${messageType === "success" ? "alert-success" : "alert-danger"}`}>
                  {message}
                </div>
              )}

        <div className='row'>
          <div className='col-12 col-md-6 offset-md-3'>
            <div className='card mt-4'>
              <div className='card-header d-flex justify-content-between align-items-center'>
                <span>Initier infos d'Acte de Vente</span>
                <button onClick={retour} className='btn btn-secondary btn-sm'>
                  Retour
                </button>
              </div>

              <div className='card-body'>
                <form onSubmit={handleSubmit}>

                  <div className='mb-3'>
                    <label htmlFor='type_acte' className='form-label'>
                      Selectionner Type Acte
                    </label>
                    <select 
                    className='form-select form-select-sm' 
                    id='id_type_acte'
                    value={id_type_acte}
                    onChange={(e) => setIdTypeActe(e.target.value)}
                    required
                    >
                      <option value="">Selectionner type acte</option>
                      {typesActe.map((type_acte) => (
                        <option key={type_acte.id} value={type_acte.id}>
                          {type_acte.libelle}
                        </option>
                      ))}
                    </select>
                  </div>

                 { id_type_acte && (
          (id_type_acte === '1' || id_type_acte === '2') ? (
    // Cas Type Acte 1 ou 2 : Affiche 2 champs
    <>
      <div className='mb-3'>
        <label htmlFor='date_acte_vente' className='form-label'>
          Date de l'Acte de Vente
        </label>
        <input
          type='date'
          className='form-control form-control-sm'
          id='date_acte_vente'
          value={date_acte_vente}
          onChange={(e) => setDateActeVente(e.target.value)}
          required
        />
      </div>

      <div className='mb-3'>
        <label htmlFor='num_acte_vente' className='form-label'>
          Numéro Acte de Vente
        </label>
        <input
          type='text'
          className='form-control form-control-sm'
          id='num_acte_vente'
          placeholder='Entrez le numéro acte de la vente'
          value={num_acte_vente}
          onChange={(e) => setNumActeVente(e.target.value)}
          required
        />
      </div>
    </>
  ) : (
    // Sinon : afficher tout le reste
    <>
      <div className='mb-3'>
        <label htmlFor='id_imam' className='form-label'>Vendu par</label>
        <select
          className='form-select form-select-sm'
          id='id_imam'
          value={id_imam}
          onChange={(e) => setIdImam(e.target.value)}
          required
        >
          <option value=''>Sélectionner Imam</option>
          {allImames.map((imam) => (
            <option key={imam.id} value={imam.id}>
              {imam.nom}
            </option>
          ))}
        </select>
      </div>

      <div className='mb-3'>
        <label htmlFor='date_acte_vente' className='form-label'>
          Date de Vente
        </label>
        <input
          type='date'
          className='form-control form-control-sm'
          id='date_acte_vente'
          value={date_acte_vente}
          onChange={(e) => setDateActeVente(e.target.value)}
          required
        />
      </div>

      <div className='mb-3'>
        <label htmlFor='num_acte_vente' className='form-label'>
          Numéro de Vente
        </label>
        <input
          type='text'
          className='form-control form-control-sm'
          id='num_acte_vente'
          placeholder='Entrez le numéro de vente'
          value={num_acte_vente}
          onChange={(e) => setNumActeVente(e.target.value)}
          required
        />
      </div>

      <div className='mb-3'>
        <label htmlFor='montant' className='form-label'>
          Montant
        </label>
        <input
          type='number'
          className='form-control form-control-sm'
          id='montant'
          placeholder='Entrez le montant'
          value={montant}
          onChange={(e) => setMontant(e.target.value)}
          required
        />
      </div>

      <div className='mb-3'>
        <label htmlFor='num_acte_depo' className='form-label'>
          Numéro Dépôt
        </label>
        <input
          type='text'
          className='form-control form-control-sm'
          id='num_acte_depo'
          placeholder='Entrez le numéro de dépôt'
          value={num_acte_depo}
          onChange={(e) => setNumActeDepo(e.target.value)}
          required
        />
      </div>

      <div className='mb-3'>
        <label htmlFor='date_acte_depo' className='form-label'>
          Date Dépôt
        </label>
        <input
          type='date'
          className='form-control form-control-sm'
          id='date_acte_depo'
          value={date_acte_depo}
          onChange={(e) => setDateActeDepo(e.target.value)}

          required
        />
      </div>
    </>
  )
)}

                  <button type='submit' className='btn btn-success btn-sm w-100' disabled={isSubmitting}>

                    {isSubmitting ? 'En cours...' : "Initier"}

                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActeVente;

                  